export default __webpack_public_path__ + "static/media/Screenshot 2.a7bf0232.png";